<template>
    <div>
        <wx-open-launch-weapp username="gh_96d43fcb44bf"
            path="/pages/hvac/member/auth">
            <script type="text/wxtag-template">
                <div>打开小程序1</div>
            </script>
        </wx-open-launch-weapp>
    </div>
</template>

<script>
import { getWxSingleConfig } from "@/js/wx.js";
export default {
    name: 'index',
    created(){
        // this.$eruda.init();
        // var initResult = await clouddev.doLogin('wx6c1fa6673a17c2d8', 'snsapi_base',window.location.href,false)
        // console.log(initResult)
        getWxSingleConfig().then(res=>{

        })
    }
}
</script>

<style lang='scss' scoped>
</style>